export default __webpack_public_path__ + "static/media/portfolio-smiles-6.6af88d7b.png";